import React from "react";
import { Link } from "react-router-dom";
import "../css/BlogCard.css";

const calculateReadTime = (content) => {
  const wordsPerMinute = 200;
  const wordCount = content?.split(/\s+/)?.length || 0;
  const readTime = Math.ceil(wordCount / wordsPerMinute);
  return readTime;
};

const BlogCard = ({ title, date, description, content, tags, id }) => {
  const readTime = calculateReadTime(content);

  return (
    <Link to={`/blog/${id}`} className="blog-card">
      <div className="blog-card-content">
        <div className="blog-card-tags">
          {tags.map((tag, index) => (
            <span key={index} className="blog-card-tag">
              {tag}
            </span>
          ))}
        </div>
        <h2 className="blog-card-title">{title}</h2>
        <p className="blog-card-description">{description}</p>
        <div className="blog-card-meta">
          <div className="blog-card-date">{date}</div>
          <div className="blog-card-read-time">{readTime} min read</div>
        </div>
      </div>
    </Link>
  );
};

export default BlogCard;
